import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=3a71bdaf&scoped=true&"
import script from "./AlertView.vue?vue&type=script&lang=js&"
export * from "./AlertView.vue?vue&type=script&lang=js&"
import style0 from "./AlertView.vue?vue&type=style&index=0&id=3a71bdaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71bdaf",
  null
  
)

export default component.exports